import { useRef, useState } from 'react'

import { getRulesFilters } from '../../../api/rules'
import useApiCall from '../../../api/useApiCall'
import { ReactComponent as Filter } from '../../../assets/icons/filter.svg'
import useOnClickOutside from '../../../hooks/useOnClickOutside'
import LoadingSection from '../../LoadingSection/LoadingSection'

import RulesFiltersMenu from './RulesFiltersMenu/RulesFiltersMenu'
import RulesFiltersOptions from './RulesFiltersOptions/RulesFiltersOptions'

import { joinClassNames } from '../../../utils/styles'
import styles from './rules-filters.module.scss'

export enum RulesFiltersEnum {
    'INTENTS' = 'intents',
    'ACTIONS' = 'actions',
}

function RulesFilters() {
    const [{ data: filtersOptions, loading }] = useApiCall(getRulesFilters)

    const filtersRef = useRef<HTMLDivElement>(null)
    const [areFiltersOpen, setAreFiltersOpen] = useState(false)
    const [category, setCategory] = useState(RulesFiltersEnum.INTENTS)

    useOnClickOutside(filtersRef, () => setAreFiltersOpen(false))

    if (loading) {
        return <LoadingSection />
    }

    if (!filtersOptions) {
        return null
    }

    const { intent_names: intents, action_names: actions } = filtersOptions

    return (
        <div className={styles.rulesFilters__wrapper}>
            <button
                className={joinClassNames(
                    styles.rulesFilters__btn,
                    areFiltersOpen && styles.rulesFilters__btnActive
                )}
                onClick={() =>
                    setAreFiltersOpen((areFiltersOpen) => !areFiltersOpen)
                }
            >
                <Filter className={styles.rulesFilters__btnIcon} />
            </button>
            {areFiltersOpen && (
                <div className={styles.rulesFilters} ref={filtersRef}>
                    <RulesFiltersMenu
                        category={category}
                        setCategory={setCategory}
                    />
                    <RulesFiltersOptions
                        category={category}
                        filtersOptions={{ intents, actions }}
                    />
                </div>
            )}
        </div>
    )
}

export default RulesFilters
